import { NAME_MAX, ROOM_RE } from '../../../../shared/limits';

// 이름 입력(친구 고르기 다음 단계)과 초대 링크. 모양은 index.html의 #name-entry (게임처럼 어두운 판, 갈무리11).
// 입력칸이 열려 있는 동안 게임 입력은 잠근다(G.input.locked): 글자를 치는 키가 게임 조작으로 들어가지 않게.
const G = (window as any).G;

// 초대 링크 방: ?room= 이 없거나 형식이 틀리면 무작위로 만들어 주소창에 넣는다 (v2와 같다). 같은 링크를 연 사람끼리 한 방이다
const randomRoom = () => Array.from({ length: 6 }, () => 'abcdefghijklmnopqrstuvwxyz0123456789'[Math.random() * 36 | 0]).join('');
let room = '';
export const roomName = () => room;
const inviteUrl = () => `${location.origin}${location.pathname}?room=${room}`;

export function initRoom() {
  const q = new URLSearchParams(location.search), want = (q.get('room') || '').toLowerCase();
  room = ROOM_RE.test(want) ? want : randomRoom();
  q.set('room', room);
  try { history.replaceState(null, '', '?' + q.toString()); } catch (e) { /* file:// 등 */ }
}

// 초대 링크 복사: 이름 상자의 복사 단추와 도구 막대의 초대 단추가 같이 쓴다. done = 복사됨, fail = 직접 복사해야 함(링크는 입력칸에서)
export function copyInvite(done: () => void, fail: () => void) {
  const url = inviteUrl(), fallback = () => { const f = $('invite') as HTMLInputElement; f.value = url; f.select(); try { if (document.execCommand('copy')) return done(); } catch (e) { /* 아래 */ } fail(); };
  navigator.clipboard ? navigator.clipboard.writeText(url).then(done, fallback) : fallback();
}

const $ = (id: string) => document.getElementById(id) as HTMLElement;
let done: ((name: string | null) => void) | null = null;

function close(name: string | null) {
  const cb = done;
  if (!cb) return;
  done = null;
  $('name-entry').hidden = true;
  G.input.locked = false;
  (document.getElementById('game') as HTMLElement).focus();
  cb(name);
}

// 이름 입력을 연다. initial = 처음 보일 이름. 확정하면 done(이름), 취소(Esc)하면 done(null)
export function askName(initial: string, cb: (name: string | null) => void) {
  const input = $('nick') as HTMLInputElement;
  done = cb;
  input.value = initial;
  ($('invite') as HTMLInputElement).value = inviteUrl();
  $('name-entry').hidden = false;
  G.input.locked = true;
  input.focus(); input.select();
}

export function initEntry() {
  const input = $('nick') as HTMLInputElement, copy = $('copy');
  input.maxLength = NAME_MAX;
  $('nick-label').textContent = `이름 (최대 ${NAME_MAX}자)`;
  const ok = () => close(input.value.trim().slice(0, NAME_MAX) || '손님');
  input.addEventListener('keydown', (e) => {
    if (e.isComposing || e.keyCode === 229) return;   // 한글 조합 중의 Enter는 글자를 확정할 뿐이다
    if (e.key === 'Enter') ok(); else if (e.key === 'Escape') close(null);
  });
  $('name-ok').addEventListener('click', ok);
  $('name-back').addEventListener('click', () => close(null));
  copy.addEventListener('click', () => {
    const flash = (t: string) => { copy.textContent = t; setTimeout(() => { copy.textContent = '복사'; }, 1500); };
    copyInvite(() => flash('복사됨'), () => flash('직접 복사'));
  });
}
